module.exports = __webpack_public_path__ + "static/00014.6ac40061.jpg";